import React, { useState } from 'react';
import TabBar from '../../component/tab-bar/tab-bar';
import { ExternalExamGroupsTab } from './tabs/external-exam-groups/external-exam-groups-tab';
import { ExternalExamsRegistrationsTab } from './tabs/external-exams-registrations/external-exams-registrations-tab';
import '../settings/studies/studies.settings.css';

const tabs = ['מקבצי בחינות', 'ניהול הרשמות'];

export const ExternalExams = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
  };

  const elementTabs = [
    <ExternalExamGroupsTab />,
    <ExternalExamsRegistrationsTab />,
  ];

  return (
    <div className={'studies-settings-root'}>
      <div style={{ width: '100%' }} className={'studies-settings-body-page'}>
        <div className={'studies-settings-title'}>מבחנים חיצוניים</div>

        <TabBar
          tabs={tabs}
          onClick={(index) => {
            onTabSelected(index);
            console.log('The index ' + index + 'Is clicked');
          }}
        ></TabBar>

        {elementTabs[selectedIndex]}
      </div>
    </div>
  );
};
